import React, { useState } from 'react';
import { Alert, Card } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import saveAs from 'file-saver';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { Role } from '../../../common/spdCore/authorization/roles';
import { Filter, FilterReportData } from '../RegistersView/Filter';
import { Waiting } from '../../../common/components/Waiting/Waiting';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';

export const DownloadSalesInvoicesView: React.FC = () => {
  const spd = useSpdCore();
  const [waiting, setWaiting] = useState<boolean>(false);
  const [alert, setAlert] = useState<string>('');

  const onSearch = async (filter: FilterReportData) => {
    setAlert('Pobieranie faktur sprzedaży, proszę czekać...');
    setWaiting(true);

    const currentDate = new Date().toISOString().split('T')[0];
    try {
      const blob = await spd.downloadsFiles.downloadSalesInvoices(
        `faktury_sprzedazy_${currentDate}.zip`,
        filter,
      );
      await saveAs(blob, `faktury_sprzedazy_${currentDate}.zip`);
      setWaiting(false);
    } catch (response) {
      const err = await responseErrors(response as ResponseError);
      toast.error(err?.[0]);
      setWaiting(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <Card id="download-sales-invoices">
        <Card.Header>{'Pobieranie dokumentów - faktury sprzedaży'}</Card.Header>
        <Card.Body>
          <Filter
            onSearch={onSearch}
            roles={[Role.Admin, Role.Finance]}
            withUser={false}
            withDate={true}
            withHealthcareFacility={false}
            withCompany={true}
            dateFromText={'Data wystawienia od'}
            dateToText={'Data wystawienia do'}
            canClean={true}
            emptyOnStart={false}
          />
        </Card.Body>
      </Card>
      {waiting && (
        <>
          <Alert variant="warning">{alert}</Alert>
          <Waiting />
        </>
      )}
    </>
  );
};
